export default {"src":"/_next/static/media/favicon-120x120.f0487098.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};